var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150pt",
    height: "148pt",
    viewBox: "0 0 150.000000 148.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,148.000000) scale(0.100000,-0.100000)",
    fill: "#757575",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707 1406 c-3 -8 1 -22 8 -33 23 -30 18 -33 -48 -33 -244 0 -484 -204 -531 -450 -14 -73 -9 -94 19 -88 14 2 23 22 37 77 57 232 234 386 470 408 71 6 82 0 48 -30 -11 -9 -20 -21 -20 -26 0 -16 29 -33 42 -25 26 16 108 89 108 97 0 5 -21 33 -47 63 -46 53 -76 67 -86 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012 1349 c-107 -53 -125 -214 -32 -292 l27 -23 -53 -28 c-93 -49 -152 -136 -161 -238 l-6 -58 308 0 308 0 -6 56 c-7 65 -44 148 -84 186 -16 15 -52 40 -81 56 l-53 29 25 17 c35 22 66 87 66 136 0 136 -135 220 -258 159z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 708 c-55 -14 -115 -83 -123 -142 -9 -59 14 -125 57 -161 17 -14 29 -27 27 -28 -2 -1 -25 -13 -52 -26 -90 -45 -149 -134 -162 -243 l-7 -58 311 0 311 0 0 28 c0 42 -26 128 -49 166 -28 44 -83 93 -130 114 -20 9 -38 18 -40 19 -2 2 8 12 23 24 51 40 75 118 57 186 -15 53 -71 108 -126 122 -49 12 -47 12 -97 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297 615 c-31 -28 -57 -58 -57 -68 0 -25 27 -32 49 -13 26 23 31 20 24 -16 -11 -63 -70 -173 -121 -230 -100 -108 -204 -157 -357 -167 -87 -5 -100 -8 -103 -25 -6 -27 15 -36 83 -36 260 0 489 185 555 449 l11 43 20 -21 c23 -24 30 -26 47 -9 18 18 16 24 -41 86 l-54 58 -56 -51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.34d56a01efc2a34b0e96e87d6d90094c.svg";
export { ForwardRef as ReactComponent };